<template>
	<div class="container">
		<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
			<el-tab-pane label="查询" name="CCQuery">
				<div class="handle-box">
					<el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getWnPhoneInfo">搜索</el-button>
				</div>
				<div class="table-box" v-if="woData">
					<div class="user-info-box">
						<div class="user-info-tit">账户信息</div>
						<div class="info-box">
							<div class="info-name">当前状态：</div>
							<div class="info" style="">
								{{ woData.status }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">套餐：</div>
							<div class="info">
								{{ woData.package }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">时间：</div>
							<div class="info">
								{{ woData.openDay }}
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="批量查询" name="CCBatchQuery">
				<div class="handle-box">
					<el-button size="small" type="primary" :class="[theme]"
						@click="getbatchQueryRecord">批量查询</el-button>
					<a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="批量查询模板.txt"
						:class="[theme]">
						<i class="el-icon-download"></i>
						下载模板
					</a>
					<el-button size="small" type="primary" :class="[theme]" @click="batchQueryRecords">刷新</el-button>
				</div>
				<el-table :data="tableData2" border class="table" ref="multipleTable"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" max-height="600"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
					<el-table-column prop="count" label="总数量" align="center"></el-table-column>
					<el-table-column prop="success" label="成功" align="center"></el-table-column>
					<el-table-column prop="err" label="失败" align="center">
						<template #default="scope">
							<span style="color: #f56c6c;">{{ scope.row.err }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="time" label="时间" align="center" width="160"></el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
					<el-table-column label="操作" width="240" align="center">
						<template #default="scope">
							<a :href="scope.row.url" class="down" download="蜗牛用户信息批量查询数据.text" :class="[theme]">
								<i class="el-icon-download"></i>
								下载
							</a>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query2.pageSize" :total="pageTotal2" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>


			<el-tab-pane label="停复机" name="CCrestartRecordList">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-model="query3.agentId" filterable clearable
						placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px" v-model="query3.companyId" @change="companyChange"
						filterable clearable placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query3.phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-input size="small" v-model="query3.uid" clearable placeholder="订单编号" style="width: 230px;"
						class="handle-input mr10"></el-input>
					<el-select size="small" style="width: 100px" v-model="query3.status" filterable clearable
						placeholder="类型" class="handle-select mr10">
						<el-option v-for="item in rechargeList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 100px" v-model="query3.succeed" filterable clearable
						placeholder="状态" class="handle-select mr10">
						<el-option v-for="item in succeedList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query3.operateMsg" clearable placeholder="请输入原因"
						class="handle-input mr10" style="width: 180px;"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
						@click="getstopOrOpenRecord">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
						@click="handleCCrestartRecordListAdd">添加停复机</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
						@click="exportData" v-if="query3.operateMsg">导出</el-button>
				</div>
				<el-table :data="tableData3" border class="table" ref="multipleTable"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" max-height="600"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="agent" label="代理商" align="center" min-width="180"></el-table-column>
					<el-table-column prop="company" label="企业名称" align="center" min-width="180"></el-table-column>
					<el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
					<el-table-column prop="status" label="状态" width="90" align="center">
						<template #default="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
								v-if="scope.row.status == '提交失败'">
								<span style="color: #f56c6c;">{{ scope.row.status }}</span>
							</el-tooltip>
							<span v-else>{{ scope.row.status }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="类型" align="center" width="100">
						<template #default="scope">
							<span v-if="scope.row.type == '停机'" class="status_color2 bgred">{{ scope.row.type }}</span>
							<span v-if="scope.row.type == '开机'"
								class="status_color2 bggreen">{{ scope.row.type }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="operateMsg" label="原因" align="center"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="createdAt" label="记录时间" align="center" width="175"></el-table-column>
					<el-table-column label="复机" align="center" width="120">
						<template #default="scope">
							<span @click="getRecordVisible(scope.row)"
								style="cursor: pointer;color: #ff0000;">记录复机</span>
						</template>
					</el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
					<el-table-column prop="uid" label="订单编号" width="350" align="center">
						<template #default="scope">
							<span style="cursor: pointer;">
								<i @click="getdownloadStopOrOpenRecord(scope.row.uid)" class="el-icon-download"
									:class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
							</span>
						</template>
					</el-table-column>
				</el-table>

				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query3.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query3.pageSize" :total="pageTotal3" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="异常话单" name="CCWNAbnormalCallList">
				<div class="handle-box" style="margin-bottom: 20px;">
					<el-select size="small" @change="agentChange" v-if="isAdmin" v-model="query4.agentId" filterable
						clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-if="isSubAgent" v-model="query4.subAgentId"
						@change="getfetchDefaultCompanies" filterable clearable placeholder="子代理"
						class="handle-select mr10" style="width: 260px;">
						<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px" v-model="query4.companyId" @change="companyChange"
						filterable clearable placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query4.phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
						@click="getdxtErrRecord">搜索</el-button>
				</div>
				<el-table :data="tableData4" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					v-loading="loading">
					<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
					<el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
					<el-table-column prop="phone" label="手机号" align="center"></el-table-column>
					<el-table-column prop="phoneNumber" label="被叫号码" align="center"></el-table-column>
					<el-table-column prop="time" label="时间" align="center"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query4.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query4.pageSize" :total="pageTotal4" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

		</el-tabs>
		<el-dialog title="批量查询" v-model="CCBatchQueryVisible" width="520px" @close="closeCCBatchQueryDialog">
			<el-form label-width="120px" :model="CCBatchQueryForm" ref="CCBatchQueryForm">
				<el-form-item label="上传类型" prop="type">
					<el-radio-group v-model="CCBatchQueryForm.type">
						<el-radio label="2">手动输入</el-radio>
						<el-radio label="1">批量查询模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传文件" v-if="CCBatchQueryForm.type=='1'">
					<el-upload ref="uploadCCBatchQuery" action="/api/cc/batchQuery" :headers="token" :limit="1"
						:on-success="uploadCCBatchQuerySuccess" :auto-upload="false" :data="uploadCCBatchQueryData">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="批量查询" v-if="CCBatchQueryForm.type=='2'">
					<el-input size="small" :rows="5" type="textarea" v-model="CCBatchQueryForm.phones"
						auto-complete="off" placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeCCBatchQueryDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="CCBatchQueryForm.type == '2'"
						@click="getbatchQuery">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitCCBatchQueryUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


		<el-dialog title="添加停复机" v-model="CCrestartRecordListVisible" width="520px"
			@close="closeCCrestartRecordListDialog">
			<el-form label-width="120px" :model="CCrestartRecordListForm" ref="CCrestartRecordListForm">
				<el-form-item label="选择模式" prop="tab1">
					<el-radio-group v-model="tab1">
						<el-radio label="input">手动输入</el-radio>
						<el-radio label="fled">批量停开机模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="类型" prop="operState">
					<el-radio-group v-model="CCrestartRecordListForm.operState">
						<el-radio label="5">开机</el-radio>
						<el-radio label="4">停机</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
					<el-input size="small" :rows="5" type="textarea" v-model="CCrestartRecordListForm.phones"
						auto-complete="off" placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-else>
					<el-upload ref="uploadCCrestartRecordList" action="/api/cc/FileStopOrOpen" :headers="token"
						:limit="1" :on-success="uploadCCrestartRecordListSuccess" :auto-upload="false"
						:data="CCrestartRecordListForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="原因" prop="reason">
					<el-input size="small" :rows="5" type="textarea" v-model="CCrestartRecordListForm.reason"
						auto-complete="off" placeholder="请输入停复机原因"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeCCrestartRecordListDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
						@click="stopOrOpens">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitCCrestartRecordListUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="自动复机设置" v-model="repeatedCCrestartRecordListVisible" width="520px"
			@close="closerepeatedCCrestartRecordListDialog">
			<el-form label-width="120px" :model="repeatedCCrestartRecordListForm" ref="repeatedCCrestartRecordListForm">
				<el-form-item label="是否记录" prop="record">
					<el-radio-group v-model="repeatedCCrestartRecordListForm.record">
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否复机" prop="recover">
					<el-radio-group v-model="repeatedCCrestartRecordListForm.recover" disabled>
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="复机时间" prop="hours" v-if="repeatedCCrestartRecordListForm.record">
					<el-radio-group v-model="repeatedCCrestartRecordListForm.hours">
						<el-radio v-for="item in hoursList" :key="item.value" :label="item.value" :value="item.value"
							style="margin: 12px 52px 12px 0;">{{ item.label }}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="记录时间" prop="updatedAt">
					<el-input size="small" v-model="repeatedCCrestartRecordListForm.updatedAt" disabled></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closerepeatedCCrestartRecordListDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getRecordingRecover">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		fetchDepartment
	} from '../../api/index';
	import {
		fetchAgent,
	} from '../../api/agentIndex';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../../api/companyIndex';
	import {
		ccWnPhoneInfo,
		ccbatchQueryRecord,
		ccbatchQuery
	} from '../../api/wn.js';
	import {
		stopOrOpenRecordcc,
		stopOrOpencc,
		downloadStopOrOpenRecordcc,
		dxtRecordingRecovercc,
		ccSnailErrRecord
	} from '../../api/dijia.js';
	export default {
		name: 'CCvirtualCommerce',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				tableData1: [],
				pageTotal1: 0,
				phone: '',
				woData: '',
				query2: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user')
				},
				CCBatchQueryVisible: false,
				CCBatchQueryForm: {
					userId: localStorage.getItem('user'),
					phones: '',
					type: "2",
				},
				uploadCCBatchQueryData: {
					userId: localStorage.getItem('user')
				},
				pageTotal2: 0,
				tableData2: [],

				query3: {
					companyId: '',
					userId: localStorage.getItem('user'),
					status: '',
					phone: '',
					pageIndex: 1,
					pageSize: 10,
					uid: '',
					succeed: '',
					reason: ''
				},
				form: {
					label: '',
					value: [],
					companyId: ''
				},
				CCrestartRecordListForm: {
					phones: '',
					userId: localStorage.getItem('user'),
					reason: '',
					operState: '5'
				},
				rechargeList: [{
					value: 0,
					label: '全部'
				}, {
					value: 1,
					label: '开机'
				}, {
					value: -1,
					label: '停机'
				}],
				succeedList: [{
					value: 0,
					label: '全部'
				}, {
					value: 1,
					label: '成功'
				}, {
					value: -1,
					label: '失败'
				}],
				CCrestartRecordListVisible: false,
				multipleSelection: [],
				delList: [],
				tab1: 'input',
				repeatedCCrestartRecordListVisible: false,
				repeatedCCrestartRecordListForm: {
					record: false,
					recover: false,
					updatedAt: '',
					hours: ''
				},
				hoursList: [{
						value: 2,
						label: '2小时'
					}, {
						value: 4,
						label: '4小时'
					}, {
						value: 6,
						label: '6小时'
					},
					{
						value: 12,
						label: '12小时'
					}, {
						value: 24,
						label: '24小时'
					}
				],
				pageTotal3: 0,
				tableData3: [],


				query4: {
					companyId: '',
					userId: localStorage.getItem('user'),
					phone: '',
					pageIndex: 1,
					pageSize: 10,
					subAgentId: '',
				},
				pageTotal4: 0,
				tableData4: [],

				timeArr: [],
				path: process.env.BASE_URL,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2',
				},
				upload: false,
				isAdmin: false,
				isAgent: false,
				isCompany: false,
				isNormal: false,
				isSubAgent: false,
				activeName: 'CCQuery',
				agents: [],
				companys: [],
				departments: [],
			};
		},
		created() {
			let role = localStorage.getItem('ms_role');
			this.init();
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			if (role === 'normal') {
				this.isNormal = true;
			}
			if (role === 'company') {
				this.isCompany = true;
			}
			this.updateTabStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'CCQuery') {
					if (this.phone) {
						this.getWnPhoneInfo();
					}
				} else if (tab.props.name == 'CCBatchQuery') {
					this.batchQueryRecords();
				} else if (tab.props.name == 'CCrestartRecordList') {
					this.init();
					this.query3.companyId = '';
					this.query3.agentId = '';
					this.getstopOrOpenRecord();
				} else if (tab.props.name == 'CCWNAbnormalCallList') {
					this.query4.companyId = '';
					this.query4.agentId = '';
					this.init();
					this.getTime();
					this.getdxtErrRecord();
				}
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {

				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: ''
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query3.agentId = agentId;
				this.query3.companyId = '';
				this.query4.agentId = agentId;
				this.query4.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query3.companyId = companyId;
				this.query4.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},
			//筛选时间
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},

			getWnPhoneInfo() {
				this.woData = '';
				ccWnPhoneInfo(this.phone.trim()).then(res => {
					if (res?.code === 200) {
						this.woData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			batchQueryRecords() {
				this.loading = true;
				ccbatchQueryRecord(this.query2).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData2 = res.data.list;
						this.pageTotal2 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getbatchQuery() {
				this.loading = true;
				ccbatchQuery(this.CCBatchQueryForm).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.CCBatchQueryVisible = false;
						this.batchQueryRecords();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitCCBatchQueryUpload() {
				if (this.$refs.uploadCCBatchQuery.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadCCBatchQuery.submit();
					this.batchQueryRecords();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadCCBatchQuerySuccess(success) {
				setTimeout(() => {
					this.$refs.uploadCCBatchQuery.clearFiles();
					this.CCBatchQueryVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.batchQueryRecords();
				} else {
					this.$message.error(success.message);
				}
			},
			getbatchQueryRecord() {
				this.CCBatchQueryVisible = true;
				this.CCBatchQueryForm.phones = '';
				this.CCBatchQueryForm.type = '2';
			},
			closeCCBatchQueryDialog() {
				this.CCBatchQueryVisible = false;
			},

			exportData() {
				this.loading = true;
				let data = {
					operateMsg: this.query3.operateMsg
				};
				downloadStopOrOpenRecordcc(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '迪加停复机' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
					this.loading = false;
				});
			},
			getstopOrOpenRecord() {
				this.loading = true;
				stopOrOpenRecordcc(this.query3).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData3 = res.data.list;
						this.pageTotal3 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			copyUrl(item) {
				let cInput = document.createElement('input');
				cInput.value = item;
				document.body.appendChild(cInput);
				cInput.select();
				document.execCommand('copy');
				this.$message.success('复制成功');
				document.body.removeChild(cInput);
			},

			handleCCrestartRecordListAdd() {
				this.CCrestartRecordListVisible = true;
			},
			stopOrOpens() {
				stopOrOpencc(this.CCrestartRecordListForm).then(res => {
					if (res?.code === 200) {
						this.CCrestartRecordListVisible = false;
						this.$message.success(res.data);
						setTimeout(() => {
							this.getstopOrOpenRecord();
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitCCrestartRecordListUpload() {
				if (this.$refs.uploadCCrestartRecordList.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadCCrestartRecordList.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			closeCCrestartRecordListDialog() {
				this.CCrestartRecordListVisible = false;
				this.CCrestartRecordListForm.phones = '';
				this.CCrestartRecordListForm.operateMsg = '';
				this.CCrestartRecordListForm.reason = '';
				this.CCrestartRecordListForm.type = 'OPEN';
				this.tab1 = 'input';
			},
			//导入上传
			uploadCCrestartRecordListSuccess(success) {
				setTimeout(() => {
					this.$refs.uploadCCrestartRecordList.clearFiles();
					this.CCrestartRecordListVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.getstopOrOpenRecord();
				} else {
					// this.open(success.message);
					this.$message.error(success.message);
				}
			},
			getdownloadStopOrOpenRecord(orderId) {
				this.$confirm('确定要下载该批次数据吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							orderId: orderId
						};
						downloadStopOrOpenRecordcc(data).then(res => {
							const blob = new Blob([res], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
							});
							let downloadElement = document.createElement('a');
							let href = window.URL.createObjectURL(blob);
							downloadElement.href = href;
							let fileName = '停复机记录' + orderId + '.xlsx';
							downloadElement.download = fileName;
							document.body.appendChild(downloadElement);
							downloadElement.click();
							document.body.removeChild(downloadElement);
							window.URL.revokeObjectURL(href);
						});
					})
					.catch(() => {});
			},
			getRecordVisible(row) {
				this.repeatedCCrestartRecordListVisible = true;
				this.repeatedCCrestartRecordListForm.record = row.record;
				this.repeatedCCrestartRecordListForm.recover = row.recover;
				this.repeatedCCrestartRecordListForm.id = row.id;
				this.repeatedCCrestartRecordListForm.hours = row.hours;
				this.repeatedCCrestartRecordListForm.updatedAt = row.updatedAt;
			},
			closerepeatedCCrestartRecordListDialog() {
				this.repeatedCCrestartRecordListVisible = false;
			},
			getRecordingRecover() {
				let data = {
					id: this.repeatedCCrestartRecordListForm.id,
					record: this.repeatedCCrestartRecordListForm.record,
					hours: this.repeatedCCrestartRecordListForm.hours
				};
				dxtRecordingRecovercc(data).then(res => {
					if (res?.code === 200) {
						this.repeatedCCrestartRecordListVisible = false;
						this.$message.success(res.data);
						this.getstopOrOpenRecord();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getdxtErrRecord() {
				this.loading = true;
				this.tableData4 = [];
				// 日期
				if (this.timeArr === null) {
					// this.$message.error('时间不能为空');
					// return;
					this.query4.startTime = '';
					this.query4.endTime = '';
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query4.startTime = startTime;
					this.query4.endTime = endTime;
				}
				ccSnailErrRecord(this.query4).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData4 = res.data.list;
						this.pageTotal4 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},

			// 分页导航
			handlePageChange(val) {
				if (this.activeName == 'CCQuery') {
					this.query1.pageIndex = val;
				} else if (this.activeName == 'CCBatchQuery') {
					this.query2.pageIndex = val;
					this.batchQueryRecords();
				} else if (this.activeName == 'CCrestartRecordList') {
					this.query3.pageIndex = val;
					this.getstopOrOpenRecord();
				} else if (this.activeName == 'CCWNAbnormalCallList') {
					this.query4.pageIndex = val;
					this.getdxtErrRecord();
				}
			},
			handleSizeChange(val) {
				if (this.activeName == 'CCQuery') {
					this.query1.pageSize = val;
					this.query1.pageIndex = 1; // 重置到第一页
				} else if (this.activeName == 'CCBatchQuery') {
					this.query2.pageSize = val;
					this.query2.pageIndex = 1; // 重置到第一页
					this.batchQueryRecords();
				} else if (this.activeName == 'CCrestartRecordList') {
					this.query3.pageSize = val;
					this.query3.pageIndex = 1; // 重置到第一页
					this.getstopOrOpenRecord();
				} else if (this.activeName == 'CCWNAbnormalCallList') {
					this.query4.pageSize = val;
					this.query4.pageIndex = 1; // 重置到第一页
					this.getdxtErrRecord();
				}
			},
		}
	};
</script>

<style scoped>
	.table-box {
		/* width: 1700px; */
		/* border: 1px solid #ebeef5; */
		display: flex;
		flex-direction: row;
		margin-bottom: 40px;
	}

	.user-info-box {
		/* border: 1px solid #ebeef5; */

		width: 600px;
	}

	.user-info-tit {
		background: #fafafa;
		color: #000;
		font-weight: 600;
		text-align: center;
		line-height: 34px;
		border-right: 1px solid #ebeef5;
		border-bottom: 1px solid #ebeef5;
	}

	.info-box {
		display: flex;
		flex-direction: row;
		line-height: 34px;
		border-bottom: 1px solid #ebeef5;
		border-right: 1px solid #ebeef5;
	}

	.info-name {
		background: #fafafa;
		border-right: 1px solid #ebeef5;
		border-left: 1px solid #ebeef5;
		width: 30%;
		padding-left: 10px;
		font-weight: 600;
	}

	.user-info-box .info-box .info {
		padding-left: 10px;
		color: #226003;
		width: 80%;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;
		display: inline-block;
	}
</style>